import { render, staticRenderFns } from "./RestablecerContrasena.vue?vue&type=template&id=62f30870&"
import script from "./RestablecerContrasena.vue?vue&type=script&lang=js&"
export * from "./RestablecerContrasena.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports